import Button from "shared/components/Button";
import { ReactComponent as CrossSVG } from "assets/icons/cross.svg";
import { Transition } from "react-transition-group";
import { useEffect, useRef, useState } from "react";
import { TransitionProps } from "react-transition-group/Transition";

/**
 * `$transitionShortMedium` in,
 * `$transitionShort` out
 */
const TIMEOUTS: TransitionProps["timeout"] = {
  enter: 0,
  appear: 450,
  exit: 300,
};

interface PopupMessageProps {
  closeButton: "X" | "Close" | string;
  widthClass?: "FullWidth" | "";
  closePanel: VoidFunction;
  immediateCallback?: VoidFunction;
}

const PopupMessage: React.FC<React.PropsWithChildren<PopupMessageProps>> = ({
  closeButton,
  widthClass = "",
  closePanel,
  immediateCallback,
  children,
}) => {
  const nodeRef = useRef<HTMLDivElement>(null);
  const [isIn, setIsIn] = useState<boolean>(false);

  // Wrapper for panel enter animation timing
  useEffect(() => {
    setTimeout(() => {
      setIsIn(true);
    }, TIMEOUTS.enter);
  }, []);

  // Wrapper for closePanel to account for animation timing
  const closePanelInner = () => {
    setIsIn(false);
    immediateCallback && immediateCallback();
    setTimeout(() => {
      closePanel();
    }, TIMEOUTS.exit);
  };

  return (
    <Transition
      nodeRef={nodeRef}
      in={isIn}
      timeout={TIMEOUTS}
      mountOnEnter
      unmountOnExit
    >
      {(transitionState) => (
        <div
          ref={nodeRef}
          className={`PopupMessage ${widthClass} ${transitionState}`}
        >
          <div className="PopupMessageInner">{children}</div>
          {closeButton !== "X" ? (
            <Button
              colour="ThemeAlt"
              additionalClassNames="NoBorder NoBackground"
              onClick={closePanelInner}
              children={closeButton}
            />
          ) : (
            <Button
              colour="ThemeAlt"
              onClick={closePanelInner}
              additionalClassNames="NoBorder NoBackground"
              children={
                <CrossSVG
                  height={14}
                  width={14}
                  role="img"
                  aria-label="Close Panel"
                  title="Close Panel"
                />
              }
            />
          )}
        </div>
      )}
    </Transition>
  );
};

export default PopupMessage;
